import moment from "moment";

const defaultRender = (value) => (value ? value : "--");

const columns = [
   {
    title: "Created By",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "Task Name",
    dataIndex: "task_name",
    render: defaultRender,
  },
  {
    title: "Notes",
    dataIndex: "fileNotes",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: (value) => moment(value).format("lll") || "--",
  },
  {
    title: "Updated Date",
    dataIndex: "latest_updated_at",
    render: (value) => moment(value).format("lll") || "--",
  },
];

export default columns;